export enum Option {
  OperationYears = 'operationYears',
  Industry = 'industry',
}
